import React from 'react';
import { Box, Divider, ListItemButton, Popover, PopoverOrigin, Stack } from '@mui/material';

import palette from '@/theme/palette';

import { styles } from './styles';

type TValueSelectorBodyProps = {
  handleClear: () => void;
  handleApplySelection: () => void;
  anchorEl: undefined | HTMLElement;
  setAnchorEl: (anchorEl: undefined | HTMLElement) => void;
  anchorOrigin: PopoverOrigin;
  children: React.ReactNode;
};

export const ValueSelectorBody = ({
  handleClear,
  handleApplySelection,
  anchorEl,
  setAnchorEl,
  anchorOrigin,
  children,
}: TValueSelectorBodyProps) => {
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(undefined);
  };

  const handleCancel = () => {
    setAnchorEl(undefined);
    handleClear();
  };

  return (
    <Popover
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      sx={styles.menu}
      anchorOrigin={anchorOrigin}
    >
      <Box>
        {children}
        <Divider />
        <Stack sx={styles.buttonWrapper} direction={'row'}>
          <Stack direction={'row'}>
            <ListItemButton onClick={handleCancel} sx={{ color: palette.text.secondary }}>
              Zrušit
            </ListItemButton>
            <ListItemButton onClick={handleApplySelection}>Potvrdit</ListItemButton>
          </Stack>
        </Stack>
      </Box>
    </Popover>
  );
};
